<template>
	<div class="modal-body pt-0 pt-md-3">
		<div class="col-12 pl-0 pr-0 d-flex flex-wrap justify-content-center">
			<div class="col-6 col-md-5 text-center" v-if="success">
				<img class="img-fluid" src="/assets/modal/smile-woman.svg">
			</div>
			<div class="col-6 col-md-5 text-center" v-else>
				<img class="img-fluid" src="/assets/modal/surprise-woman.svg">
			</div>
			<div class="col-12 col-md-7 pt-3 pt-md-0 mt-auto mb-auto text-center text-md-left">
				<div class="font-size-11 font-weight-bold">{{title}}</div>
				<div class="font-size-10 pt-2" v-html="message"></div>
			</div>
		</div>
		<div class="col-12 pl-0 pr-0 pt-3 d-flex justify-content-center justify-content-md-end" v-if="type == 'alert'">
			<button @click="remove" class="col-5 col-md-3 btn btn-blue d-flex d-flex justify-content-center rounded-cus ml-3">
				<span class="font-size-11"><i class="fas fa-check"></i></span>
				<div class="font-size-11 pl-2">OK</div>
			</button>
		</div>
		<div class="col-12 pl-0 pr-0 d-flex justify-content-center justify-content-md-end" v-if="type == 'confirmation'">
			<button class="col-3 btn btn-outline-danger d-flex justify-content-center rounded-cus" @click="remove" :disabled="progressStatus == 'start'">
				<span class="font-size-11"><i class="fas fa-times"></i></span>
				<div class="font-size-11 pl-2">{{ closeText }}</div>
			</button>
			<button class="col-3 btn btn-blue d-flex d-flex justify-content-center rounded-cus ml-3" @click="confirm" :disabled="progressStatus == 'start'">
				<span class="font-size-11"><i class="fas fa-check"></i></span>
				<div class="font-size-11 pl-2">{{ confirmText }}</div>
			</button>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
	props: {
		title: {
			type: String,
			default: 'Oops!',
		},
		message: {
			type: String,
			default: '',
		},
		type: {
			type: String,
			default: 'alert',
		},
		success: {
			type: Boolean,
			default: false
		},
		closeText: {
			type: String,
			default: 'Batal'
		},
		confirmText: {
			type: String,
			default: 'Yakin'
		}
	},
	computed: {
		...mapState(['progressStatus']),
	},
	methods:{
		remove(){
			this.$emit('remove')
		},
		confirm(){
			this.$emit('confirm')
		}
	}
};
</script>

<style scoped>
.close {
	float: none;
	position: absolute;
	right: 10px;
	top: 10px;
}
</style>
